import { WithTooltip } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { PunchOutSupplierIconStyled } from './styles/PunchOutSupplierIconStyled'

export interface IPunchOutSupplierIconProps {
  /**
   * Sets the supplier icon size
   */
  size?: 'xsmall' | 'small' | 'medium' | 'large'
  /**
   * PunchOut supplier name
   */
  name: string
  /**
   * PunchOut supplier icon url
   */
  iconUrl: string
  /**
   * Hides the icon from assistive tech and drops its name tooltip. Use it when
   * visible text beside the icon already names the supplier, so the supplier
   * is not announced twice.
   */
  decorative?: boolean
}

export const PunchOutSupplierIcon = ({
  size = 'medium',
  name,
  iconUrl,
  decorative = false,
}: IPunchOutSupplierIconProps) => {
  const intl = useProcurifyIntl()

  return iconUrl && name ? (
    <PunchOutSupplierIconStyled size={size}>
      <WithTooltip title={name} placement='top' isDisabled={decorative}>
        <img
          src={iconUrl}
          alt={
            decorative
              ? ''
              : intl.formatMessage(messages.imageAltText, {
                  name,
                })
          }
          aria-hidden={decorative || undefined}
        />
      </WithTooltip>
    </PunchOutSupplierIconStyled>
  ) : null
}

PunchOutSupplierIcon.displayName = 'PunchOutSupplierIcon'
